import React, { useState, useEffect } from 'react';
import { ListItem, Box, Typography, Grid, IconButton } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

const Channel = ({ Name, Image, Shift, Number, id, selected, selectEvent, virtualScrollStyle }) => {
    const [favorite, setFavorite] = useState(null);

    useEffect(() => {
        if (selected) {
            setTimeout(() => {
                const selectedCh = document.getElementById('selectedCh');
                if (selectedCh) {
                    selectedCh.className += ' hvr-shutter-in-horizontal-on';
                }
            }, 100);
        }
    }, [selected]);

    const setFavoriteGlob = (event) => {
        event.stopPropagation();
        setFavorite(!favorite);
    };

    return (
        <ListItem
            button
            onClick={!selected ? selectEvent : undefined}
            style={virtualScrollStyle}
            selected={selected}
            id={selected ? 'selectedCh' : ''}
            sx={{
                width: '100%',
                transition: 'all 0.3s ease',
                '&:hover': {
                    borderBottom: 'none',
                    cursor: 'pointer',
                },
                '& + &': {
                    paddingBottom: 2,
                },
            }}
            className={selected ? 'hvr-grow-shadow hvr-shutter-in-horizontal' : 'hvr-reveal hvr-grow-shadow'}
        >
            <Box sx={{ width: '100%' }}>
                <Grid container alignItems="center">
                    <Grid item xs={2}>
                        <Box
                            sx={{
                                backgroundImage: `url(${Image})`,
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                                minHeight: 30,
                                maxHeight: 30,
                                borderRadius: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        />
                    </Grid>
                    <Grid item xs={8}>
                        <Box sx={{ textTransform: 'capitalize', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                            <Typography variant="h7" component="div" sx={{ fontSize: '1rem', maxWidth: '100%', color: "#adadad" }}>
                                <b>{Name}</b>
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={2} container alignItems="center" justifyContent="flex-end">
                        <IconButton onClick={setFavoriteGlob} color="#adadad">
                            {favorite ? <StarIcon /> : <StarBorderIcon />}
                        </IconButton>
                    </Grid>
                </Grid>
            </Box>
        </ListItem>
    );
};

export default Channel;
